












































































































































import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { LoginModel } from '@/models/admin/users';
import { VFields } from '@/models/v-fields';
import { accountService, storeService, userService } from '@/shared';
import { Utils } from '@/helper/utils';
import { CookieHelper } from '@/helper/cookie.helper';
import {
  GetAuthenticationQrCodeResponse,
  PhoneNumberDataViewModel,
} from '@/Alynk.dtos';
import { Base } from '@/components/common/base';
import { NotificationHelper } from '@/helper/notifications.helper';

@Component({})
class LoginPage extends Vue {
  public title: string = 'AL- AutomotiveLynk- LOGIN PAGE';
  public isAuthenticate: boolean = false;
  public isShownTryAnotherWay: boolean = false;
  public isShownOTPMessage: boolean = false;
  public isEnableSmsOTP: boolean = false;
  public isSmsOTP: boolean = false;
  public isResendSms: boolean = false;
  public qrcodeImageUrl: string;
  public authResponse: GetAuthenticationQrCodeResponse;
  public otpValue: string = '';
  public otpCounter: number = 0;
  public smsOtpNumber: any = 0;
  public isShownAlert: boolean = false;
  public isAuthScreenLoading: boolean = false;
  public checkbox: boolean = false;
  public loginModel: LoginModel = {
    email: '',
    password: '',
    rememberMe: false,
  };
  public store: any = {
    tenantId: 0,
    enterpriseId: 0,
    storeId: 0,
    name: '',
  };

  public loginFields: Array<VFields<string>> = [];
  public form: any = {};
  public stores: any[] = [];
  public loginButtonDisabled: boolean = false;
  public requestProgress: boolean = false;
  public otpRequestProgress: boolean = false;
  public smsOtpRequestProgress: boolean = false;
  public showPassword: boolean = false;
  public logoPath: string;
  public isLoadUserLogin = false;

  public created() {
    // this.logoPath = require("@/assets/"+Utils.AppEnvironmentName+"logo-1.png");
    this.logoPath = Utils.blobBaseUrl + "logo-1.png";
  }

  public async mounted() {
    try
    {
      // this.storeService = new StoreService();
      // this.userService = new UserService();
      this.setLoginFormFields();

      accountService.RemoveUserSession();

      const sid = this.$route.query.sid?.toString();
      if(sid != undefined && sid.startsWith("al"))
      {
        this.startLoading();

        const loginResponse = await accountService.validateSecureLogin(this.$route.query.sid.toString());
        if(loginResponse.isSessionValid){
          localStorage.setItem('bearerToken', this.$route.query.sid.toString());
          localStorage.setItem('refreshToken', this.$route.query.sid.toString());
          CookieHelper.setCookie('bearerToken', this.$route.query.sid.toString());
          await this.getAuthQrcode();
        }
        else
        {
          this.showAlert(loginResponse.isSessionValid, loginResponse.message);
          
          setTimeout(async()=>{
            accountService.logout(this);
          }, 1500);
        }
      }
      else
      {
        //SSO login moved to Alynk V2

        // const response = await accountService.getEnvConfig(["config_IsEnableSSOLogin"]);
        // localStorage.setItem("ssoEnabled", response.envVars.config_IsEnableSSOLogin);
        // console.log("SSO Enabled: " + this.$store.getters.getIsSSOenabled);

        // if(response.envVars.config_IsEnableSSOLogin == 'true' && !this.$route.query.sid)
        // {
        //   window.open(process.env.VUE_APP_ALYNK_V2_BASE_URL, "_self");
        //   return;
        // }
        // else if(response.envVars.config_IsEnableSSOLogin == 'false')
        // {
        //   this.isLoadUserLogin = true;
        //   await this.$nextTick();
        // }
      }
    }
    finally
    {
      this.hideLoading();
    }
  }

  public setLoginFormFields(): void {
    this.loginFields = [
      {
        key: 'email',
        required: true,
        type: 'v-alynk-text-field',
        validators: {
          email: (field, model, next) => {
            next(Utils.EmailRegex.test(model[field.key]));
          },
        },
        templateOptions: {
          required: true,
          placeholder: this.$parent.$tc('loginScreen.textFields', 1) as string,
          validations: 'required|email',
          label: this.$parent.$tc('loginScreen.textFields', 1) as string,
          disabled: false,
          type: 'email',
          // prependIcon: 'mdi-account-circle', // 'fas fa-envelope',
          rules: [
            (v) =>
              !!v || (this.$parent.$t('loginScreen.emailRequired') as string),
          ],
        },
      },
      {
        key: 'password',
        required: true,
        type: 'v-alynk-text-field',
        templateOptions: {
          label: this.$parent.$tc('loginScreen.textFields', 2) as string,
          placeholder: this.$parent.$tc('loginScreen.textFields', 2) as string,
          counter: 20,
          required: true,
          type: this.showPassword ? 'text' : 'password',
          validations: 'required',
          disabled: false,
          // prependIcon: 'mdi-lock',
          appendIcon: this.showPassword ? 'mdi-eye' : 'mdi-eye-off',
          events: {
            onClick: (showPassword) => {
              this.SetPasswordToggle();
            },
          },
          rules: [
            (v) =>
              !!v ||
              (this.$parent.$t('loginScreen.passwordRequired') as string),
          ],
        },
      },
    ];
  }

  public loginValidation(): Vue & { validate: () => boolean } {
    return this.$refs.loginform as Vue & { validate: () => boolean };
  }

  public async login() {
    if (this.loginValidation().validate()) {
      try {
        this.requestProgress = true;
        this.loginModel.email = this.loginModel.email.trim();
        this.loginModel.password = this.loginModel.password.trim();
        if (this.loginModel.email && this.loginModel.password) {
          const login = await accountService.login(this.loginModel);
          localStorage.setItem('bearerToken', login.bearerToken);
          localStorage.setItem('refreshToken', login.refreshToken);
          CookieHelper.setCookie('bearerToken', login.bearerToken);
          await this.getAuthQrcode();
        }
      } finally {
        this.requestProgress = false;
        this.isAuthScreenLoading = false;
      }
    }
  }

  public async getAuthQrcode() {
    this.authResponse = await userService.getAuthenticationQr();
    this.qrcodeImageUrl = this.authResponse.qrImageUrl
      ? this.authResponse.qrImageUrl
      : '';
    if (this.authResponse.isAuthenicationEnabled) {
      this.isAuthenticate = true;
      // this.isShownOTPMessage =  this.authResponse.qrImageUrl == '' ? true : false;
    } else {
      await this.getDefaultStores();
    }
  }

  public Cancel() {
    this.isEnableSmsOTP = false;
    this.isSmsOTP = this.authResponse.qrImageUrl != '' ? false : true;
    this.isResendSms = false;
    this.isShownTryAnotherWay = false;
  }
  public CancelVerifyOTP() {
    this.isAuthenticate = false;
  }

  public async SendOtp() {
    if (this.smsOtpNumber.phoneNumber != undefined) {
      try {
        this.smsOtpRequestProgress = true;
        const response = await userService.GetAuthenticationOtp(
          this.smsOtpNumber
        );
        if (response.status == true) {
          this.smsOtpRequestProgress = false;
          this.isEnableSmsOTP = false;
          this.isSmsOTP = true;
          this.isResendSms = true;
          this.isShownTryAnotherWay = false;
          this.isShownOTPMessage = true;
        } else {
          this.smsOtpRequestProgress = false;
          this.otpCounter++;
          this.isShownAlert = true;
          if (this.isShownAlert) {
            this.showAlert(false, 'Invalid OTP');
            this.otpValue = '';
          }
        }
      } finally {
        this.requestProgress = false;
      }
    }
  }

  public showAlert(status: boolean, message: any, timeOut: number = null) {
    NotificationHelper.showAlert(status, message, this, timeOut);
  }

  public async verifyOtp() {
    this.isShownAlert = false;
    const code = this.otpValue;
    if (code && code != '') {
      try {
        this.otpRequestProgress = true;
        const otpTypeValue = this.isSmsOTP ? 'OTP' : 'TOTP';
        const response = await userService.veirfyUserCode(
          code,
          otpTypeValue,
          this.checkbox
        );
        if (response.status == true) {
          // CookieHelper.setCookie('TrustedDevice', JSON.stringify(response.token), 30);
          this.otpCounter = 0;
          await this.getDefaultStores();
        } else {
          this.otpRequestProgress = false;
          this.otpCounter++;
          this.isShownAlert = true;
          if (this.isShownAlert) {
            this.showAlert(false, 'Invalid OTP');
            this.otpValue = '';
          }
          if (this.otpCounter > 3) {
            localStorage.removeItem('userId');
            localStorage.removeItem('userName');
            localStorage.removeItem('displayName');
            localStorage.removeItem('bearerToken');
            localStorage.removeItem('refreshToken');
            this.isAuthenticate = false;
            this.otpCounter = 0;
          }
        }
      } finally {
        this.otpRequestProgress = false;
        this.requestProgress = false;
      }
    }
  }

  public tryAnotherWay() {
    // this.isShownAlert = false;
    this.isEnableSmsOTP = true;
    this.isShownTryAnotherWay = true;
    this.isShownOTPMessage = false;
    this.otpValue = '';
  }

  public async getDefaultStores(): Promise<void> {
    let isRedirection = false;
    if (this.$route.query && this.$route.query.redirectUrl) {
      isRedirection = true;
    }
    const loginResponse = await storeService.getLogin(isRedirection);
    if (loginResponse.isTempPassword && !this.$route.query.sid?.toString()) {
      this.$router.push({
        name: 'app.account.changepassword',
        params: {
          id: loginResponse.userInfo.userId,
        },
      });
      return;
    }
    this.store = loginResponse.store;
    if (this.store && JSON.stringify(this.store) !== '{}') {
      if (this.store.storeId) {
        if (isRedirection) {
          this.redirectToSelectStore();
        } else {
          const userInfo = loginResponse.userInfo;
          this.$store.dispatch('setAppStores', userInfo.stores || []);
          this.$store.dispatch('setRoles', userInfo.roles || []);
          this.$store.dispatch('setUserDisplayName', userInfo.displayName);
          this.$store.dispatch('setUserEmail', userInfo.email);
          localStorage.setItem('sessionId', userInfo.sessionId);
          await this.changeStore(loginResponse);
        }
      } else {
        this.redirectToSelectStore();
      }
    } else {
      this.redirectToSelectStore();
    }
  }

  public redirectToSelectStore(): void {
    if (this.$route.query && this.$route.query.redirectUrl) {
      const url = this.$route.query.redirectUrl;
      this.$router.push({
        path: '/app/store/select',
        query: { redirectUrl: url },
      });
    } else {
      this.$router.push({ name: 'app.store.select' });
    }
  }
  public SetPasswordToggle(): void {
    this.showPassword = !this.showPassword;
    this.setLoginFormFields();
  }

  public async changeStore(loginResponse): Promise<void> {
    CookieHelper.setCookie('StoreFeatures', JSON.stringify(loginResponse.features.results));
    CookieHelper.setCookie('IsLiveCall', JSON.stringify(loginResponse.isLiveCallEnabled));

    this.$store.dispatch('setTenantInfo', {
      tenantId: this.store.tenantId,
      enterpriseId: this.store.enterpriseId,
      storeId: this.store.storeId,
    });
    if (this.store.storeId) {
      if (this.$route.query && this.$route.query.redirectUrl) {
        this.$router.push({ path: String(this.$route.query.redirectUrl) });
      } else {
        this.$router.push({
          name: 'app.dashboard',
          params: {
            tenantId: this.store.tenantId,
            enterpriseId: this.store.enterpriseId,
            storeId: this.store.storeId,
          },
        });
      }
    }
  }

  public startLoading()
  {
    const loader = document.getElementById("loader");
    loader.style.display = "flex";
  }

  public hideLoading()
  {
    const loader = document.getElementById("loader");
    loader.style.display = "none";
  }

}

export default LoginPage;

